import React, {Component} from 'react';
import {actions, ACTION_TYPES} from "../../actions";
import { connect } from "react-redux";
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Switch from '@material-ui/core/Switch';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import _ from 'lodash';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import Tooltip from '@material-ui/core/Tooltip';
import CourseSearchResult from './CourseSearchResult';
import {isAllowed, ROLES} from "../Permissions";
import Autocomplete from '@material-ui/lab/Autocomplete';

const showDiv = (user, compRoles, component) => {
    if(isAllowed(user, compRoles)) {
        return component;
    } else {
        return null;
    }
};

const AntSwitch = withStyles((theme) => ({
    root: {
        width: 28,
        height: 16,
        padding: 0,
    },
    switchBase: {
        padding: 2,
        color: theme.palette.grey[500],
        '&$checked': {
            transform: 'translateX(12px)',
            color: theme.palette.common.white,
            '& + $track': {
                opacity: 1,
                backgroundColor: theme.palette.primary.main,
                borderColor: theme.palette.primary.main,
            },
        },
    },
    thumb: {
        width: 12,
        height: 12,
        boxShadow: 'none',
    },
    track: {
        border: `1px solid ${theme.palette.grey[500]}`,
        borderRadius: 16 / 2,
        opacity: 1,
        backgroundColor: theme.palette.common.white,
    },
    checked: {},
}))(Switch);

const InfoToolTip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: '#f5f5f9',
        color: 'rgba(0, 0, 0, 0.87)',
        maxWidth: 220,
        fontSize: theme.typography.pxToRem(12),
        border: '1px solid #dadde9',
    },
}))(Tooltip);

class NewAssessmentForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            department: {name:''},
            program: {name:''},
            college:{name:''},
            outcome:{name:''},
            numArtifacts:1,
            numArtifactsPerTier:1,
            numArtifactsPerReviewer: 1,
            courses:[],
            name:'',
            terms: [],
            isAbet:false,
            checked:false,
        };
        this.handleSemesterUpdate = this.handleSemesterUpdate.bind(this);
    };

    validation() {
        if(this.props.form) {
            if(!this.props.form.outcome || !this.props.form.program || !this.props.form.courses || (this.props.form.courses && this.props.form.courses.length < 1)) {
                return false;
            }
        }
        return true;
    }

    filterList(list) {
        if(list && list.length > 0) {
            return list[0];
        }
        return null;
    }

    async componentDidMount() {
        if(this.validation()) {
            if(this.props.form.numArtifactsPerTier){
                this.setState({isAbet:true})
            }
            this.setState({college: this.props.form.college, department: this.props.form.department, program: this.props.form.program, outcome: this.props.form.outcome, numArtifacts: this.props.form.numArtifacts, term: this.props.form.term, name: this.props.form.name, numArtifactsPerReviewer: this.props.form.numArtifactsPerReviewer, checked:this.props.form.checked, numArtifactsPerTier:this.props.form.numArtifactsPerTier })
        } else {
            await this.props.fetchTerms();

            if(this.props.user.roles.includes(ROLES.ADMIN) || this.props.user.roles.includes(ROLES.COORDINATOR)) {
                await this.props.fetchColleges();
                let college = this.filterList(this.props.colleges);
                if(college) {
                    this.setState({college: college});
                    await this.props.fetchDepartments(college.id);
                }
            } else {
                await this.props.fetchDepartmentsPerUser();
            }

            let department = this.filterList(this.props.departments);
            if(department) {
                this.setState({department: department});
                await this.props.fetchPrograms(department.id);
            }
        }
    }

    renderList(list) {
        return _.map(list, option => {
            return (
                <MenuItem key={option.id} data-key={option.id} value={option.name} style={{width:'250'}}>
                    {option.name}
                </MenuItem>
            );
        });
    }

    renderOutcomeList(list) {
        let genedOutcomes = [];
        let programOutcomes = [];
        let outcomes = [];

        outcomes.push(<MenuItem disabled={true} key={'program-outcome-title'} value={'program-outcome-title'} style={{width:'250'}}>
            Program Outcomes
        </MenuItem>);

        _.map(list, option => {
            if(option.type == 'General Education') {
                genedOutcomes.push(<MenuItem key={option.id} data-key={option.id} value={option.name} style={{width:'250'}}>
                    {option.name}
                </MenuItem>)
            } else {
                programOutcomes.push(<MenuItem key={option.id} data-key={option.id} value={option.name} style={{width:'250'}}>
                    {option.name}
                </MenuItem>)
            }
        });

        outcomes.push(...programOutcomes);

        outcomes.push(<MenuItem disabled={true} key={'gen-ed-title'} value={'gen-ed-title'} style={{width:'250'}}>
            General Education Outcomes
        </MenuItem>);

        outcomes.push(...genedOutcomes);

        return outcomes;
    }

    renderTermsList(list) {
        return _.map(list, option => {
            return (
                <MenuItem key={option.canvas_term_id} data-key={option.canvas_term_id} value={option.name} style={{width:'250'}}>
                    {option.name}
                </MenuItem>
            );
        });
    }

    setStateAsync(state) {
        return new Promise((resolve) => {
            this.setState(state, resolve)
        });
    }

    handleChange = (name) => async (event) => {
        const query = event.nativeEvent.target.getAttribute('data-key');
        this.setState({
            [name]: {
                name: event.target.value,
                id: query
            }
        },()=>{
            this.state.program.name == 'ABET'? this.setState({isAbet:true}): this.setState({isAbet:false})
        });
        switch(name) {
            case 'college':
                await this.props.fetchDepartments(query);
                var department = this.filterList(this.props.departments);
                if(department) {
                    await this.setStateAsync({department: department});
                    await this.props.fetchPrograms(department.id);
                }

                var program = this.filterList(this.props.programs);
                if(program) {
                    await this.setStateAsync({program: program});
                    this.state.program.name == 'ABET'?this.setState({isAbet:true}):this.setState({isAbet:false});
                    await this.props.fetchOutcomes(program.id);
                }

                var outcome = this.filterList(this.props.outcomes);
                if(outcome) {
                    await this.setStateAsync({outcome: outcome});
                    this.props.fetchCourses({outcome_id: this.state.outcome.id, program_id: this.state.program.id, terms: this.state.terms, isAbet:this.state.isAbet});;
                } else {
                    await this.props.setNewFields({
                        type: ACTION_TYPES.FETCH_COURSES,
                        payload: {
                            courses:[]
                        }
                    })
                }
                break;
            case 'department':
                await this.props.fetchPrograms(query);
                var program = this.filterList(this.props.programs);
                if(program) {
                    await this.setStateAsync({program: program});
                    this.state.program.name == 'ABET'? this.setState({isAbet:true}): this.setState({isAbet:false});
                    await this.props.fetchOutcomes(program.id);
                }

                var outcome = this.filterList(this.props.outcomes);
                if(outcome) {
                    await this.setStateAsync({outcome: outcome});
                    this.props.fetchCourses({outcome_id: this.state.outcome.id, program_id: this.state.program.id, terms: this.state.terms, isAbet:this.state.isAbet});;
                } else {
                    await this.props.setNewFields({
                        type: ACTION_TYPES.FETCH_COURSES,
                        payload: {
                            courses:[]
                        }
                    })
                }
                break;
            case 'program':
                await this.props.fetchOutcomes(query);
                var outcome = this.filterList(this.props.outcomes);
                if(outcome) {
                    await this.setStateAsync({outcome: outcome});
                    this.props.fetchCourses({outcome_id: this.state.outcome.id, program_id: this.state.program.id, terms: this.state.terms, isAbet:this.state.isAbet});;
                } else {
                    await this.props.setNewFields({
                        type: ACTION_TYPES.FETCH_COURSES,
                        payload: {
                            courses:[]
                        }
                    })
                }
                break;
            case 'outcome':
                await this.setStateAsync({
                    outcome:{
                        name:event.target.value,
                        id:query
                    }
                })
                this.props.fetchCourses({outcome_id: this.state.outcome.id, program_id: this.state.program.id, terms: this.state.terms, isAbet:this.state.isAbet});
                break;
            default:
        }
     this.props.setNewFields({
          type: ACTION_TYPES.SET_FIELDS.SET_MULTI,
          payload: this.state
      })

    };

    handleChangeArtifacts = () => (event) => {
        const value = Math.min(parseInt(event.target.value) || 0, 150); // Cap at 150
        if(value > 0) {
            this.setState({numArtifacts: value}, () => {
                this.props.setNewFields({
                    type: ACTION_TYPES.SET_FIELDS.SET_NUM_ARTIFACTS,
                    payload: this.state.numArtifacts
                }).then(() => {
                    if(Number(this.state.numArtifacts) <= Number(this.state.numArtifactsPerReviewer)) {
                        this.setState({numArtifactsPerReviewer: this.state.numArtifacts}, () => {
                            this.props.setNewFields({
                                type: ACTION_TYPES.SET_FIELDS.SET_NUM_ARTIFACTS_PER_REVIEWER,
                                payload: this.state.numArtifactsPerReviewer
                            })
                        });
                    }
                })
            });
        }
    }

    handleChangeArtifactsPerReviewer = () => (event) => {
        const value = Math.min(parseInt(event.target.value) || 0, 150); // Cap at 150
        if(value > 0) {
            if(Number(value) <= Number(this.state.numArtifacts)) {
                this.setState({numArtifactsPerReviewer: value}, () => {
                    this.props.setNewFields({
                        type: ACTION_TYPES.SET_FIELDS.SET_NUM_ARTIFACTS_PER_REVIEWER,
                        payload: this.state.numArtifactsPerReviewer
                    })
                });
            }
        }
    }

    handleNameChange = () => (event) => {
        this.setState({name: event.target.value});
        this.props.setNewFields({
            type: ACTION_TYPES.SET_FIELDS.SET_NAME,
            payload: {
                name: event.target.value
            }
        })
    }

    returnTermList(list){
        return _.map(list, option => {
            return ({
                    name: option.name,
                    canvas_term_id: option.canvas_term_id
                }
            );
        });
    }

    handleSemesterUpdate = (event, values) => {
        this.setState({
            terms: values
        }, () => {
            this.props.setNewFields({
                type: ACTION_TYPES.SET_FIELDS.SET_TERM,
                payload: this.state.terms
            }).then(() => {
                this.props.fetchCourses({outcome_id: this.state.outcome.id, program_id: this.state.program.id, terms: this.state.terms, isAbet:this.state.isAbet});
            })
        });
    }

    handleToggle = (event, newAlignment) => {
        if(newAlignment!=null){
            this.setState({ checked:newAlignment },()=>{
                this.props.setNewFields({
                    type:ACTION_TYPES.SET_FIELDS.SET_BELL_CURVE_CHECKED,
                    payload:this.state.checked
                })
            });
        }
    };

    handleChangeArtifactsPerTier = () => (event) => {
        const value = Math.min(parseInt(event.target.value) || 0, 150); // Cap at 150
        if(value > 0) {
            this.setState({numArtifactsPerTier: value}, () => {
                this.props.setNewFields({
                    type: ACTION_TYPES.SET_FIELDS.SET_NUM_ARTIFACTS_PER_TIER,
                    payload: this.state.numArtifactsPerTier
                })
            });
        }
    }

    render() {
        let artifactFields;
        artifactFields = this.state.checked?<span>
             <TextField id="artifacts-per-tier" label="Artifacts Per Tier" value={this.state.numArtifactsPerTier} onChange={this.handleChangeArtifactsPerTier()} type="number"  style={{width: '100px', marginLeft: '5%'}}  InputProps={{ inputProps: { min: 0, max: 150 } }} helperText={this.state.numArtifactsPerTier > 150 ? "Maximum value is 150" : ""} error={this.state.numArtifactsPerTier > 150} margin="normal">
            </TextField>
        </span>:
        <span>
            <TextField id="artifacts" label="Artifacts" value={this.state.numArtifacts} onChange={this.handleChangeArtifacts()} type="number"  style={{width: '100px', marginLeft: '5%'}}  InputProps={{ inputProps: { min: 0, max: 150 } }} helperText={this.state.numArtifacts > 150 ? "Maximum value is 150" : ""} error={this.state.numArtifacts > 150} margin="normal">
            </TextField>
            <TextField id="artifacts-per-reviewer" label="# Artifacts per Reviewer" value={this.state.numArtifactsPerReviewer} onChange={this.handleChangeArtifactsPerReviewer()} type="number"  style={{width: '100px', marginLeft: '5%'}}  InputProps={{ inputProps: { min: 0, max: 150 } }} helperText={this.state.numArtifactsPerReviewer > 150 ? "Maximum value is 150" : ""} error={this.state.numArtifactsPerReviewer > 150} margin="normal">
            </TextField>
        </span>

        return (
            <div>
                <Typography variant="h3" gutterBottom>
                    Build a new Assessment
                </Typography>
                <div>
                    <form>
                        <div>
                            <TextField id="standard-name" label="Name"style={{width:'400px'}} value={this.state.name} onChange={this.handleNameChange()} margin="normal"/>
                        </div>
                        {showDiv(
                            this.props.user,
                            [ROLES.COORDINATOR, ROLES.ADMIN],
                            <div>
                                <TextField id="select-college" select label="Select College" style={{width:'400px'}} value={this.state.college.name} onChange={this.handleChange('college')} margin="normal">
                                    {this.renderList(this.props.colleges)}
                                </TextField>
                            </div>
                        )}

                        <div>
                            <TextField id="select-department" select label="Select Department" style={{width:'400px'}} value={this.state.department.name} onChange={this.handleChange('department')} margin="normal">
                                {this.renderList(this.props.departments)}
                            </TextField>
                        </div>

                        <div>
                            <TextField id="select-program" select label="Select Program" style={{width:'400px'}} value={this.state.program.name} onChange={this.handleChange('program')} margin="normal">
                                {this.renderList(this.props.programs)}
                            </TextField>
                        </div>

                        <div style={{display:'flex'}}>
                            <Autocomplete
                                multiple
                                id="tags-standard"
                                value = {this.props.form.terms}
                                options={this.returnTermList(this.props.terms)}
                                getOptionLabel={(option) => option.name}
                                defaultValue={[]}
                                getOptionSelected={(option) => this.state.terms.some(term => term.name === option.name)}
                                onChange={this.handleSemesterUpdate}
                                style={{width: '400px', marginRight:'400px'}}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="standard"
                                        label="Select Semester(s)"
                                    />
                                )}
                            />
                            {/*{this.state.isAbet &&*/}
                            <table style={{marginLeft: '4.8%'}}>
                                <th className='MuiFormLabel-root' style={{fontSize: '.78rem'}} colSpan="3"
                                    align={"left"}>
                                    Assignment Selection Type
                                    <InfoToolTip placement={"top"}
                                        title={<React.Fragment>
                                            <b>{"Random"}</b><br/>{"Returns randomly selected student submissions, which are linked to different associations of the selected course."}
                                            <br/><br/>
                                            <b>{"Select Low, Medium, and High Assignments"}</b><br/>{"Based on submission grades - returns equal numbers of assignments from low (1 standard deviation (SD) below the mean and lower), medium (-1 to +1 SD), and high (1 SD and higher above the mean) submissions."}
                                        </React.Fragment>}
                                    >
                                        <InfoOutlinedIcon style={{fontSize:"small"}}/>
                                    </InfoToolTip>
                                </th>
                                <tr>
                                    <td className='MuiInputBase-input' style={{fontSize: '.78rem'}}>
                                        Random
                                    </td>
                                    <td style={{textAlign: 'center'}}>
                                        <AntSwitch checked={this.state.checked} onChange={this.handleToggle}
                                                   name="checked"/>
                                    </td>
                                    <td className='MuiInputBase-input' style={{fontSize: '.78rem'}}>
                                        Select Low, Medium, and High Assignments
                                    </td>
                                </tr>
                            </table>
                            {/*}*/}
                        </div>

                        <div>
                            <TextField id="select-outcome" select label="Select Outcome" style={{width:'800px'}} value={this.state.outcome.name} onChange={this.handleChange('outcome')} margin="normal">
                                    {this.renderOutcomeList(this.props.outcomes)}
                            </TextField>
                            {artifactFields}
                        </div>

                        <CourseSearchResult/>
                    </form>
                </div>
            </div>);
    }
}

function mapStateToProps(state) {
    return { user: state.user, colleges: state.colleges, departments: state.departments, outcomes: state.outcomes, programs: state.programs, courses: state.courses, terms: state.terms, form: state.newAssessmentForm };
}

export default (connect(mapStateToProps,actions)(NewAssessmentForm));